/**
 * Career Plan
 *
 * //TODO: Localize
 */
$(document).on("ready", function () {
  $(document).on("click", ".addAnother", function (e) {
    e.preventDefault();
    var count = $('input[name^="strategies"]').length;
    var newCount = count + 1;
    $("#theStrats").append(
      '<div><label for="strat' +
        newCount +
        '">Strategy <small>(What step will you take to reach your goal?)</small></label><input type="text" id="strat' +
        newCount +
        '" name="strategies[' +
        newCount +
        ']" value="" placeholder="Examples: Attend study hall once a week, Take an online Excel course, Join the debate club" /><div><input type="checkbox" id="comp' +
        newCount +
        '" name="completed' +
        newCount +
        '" value="1" /><label class="comp" for="comp' +
        newCount +
        '">Strategy Completed</label></div></div>'
    );
  });
  $(".goal button").on("click", function (e) {
    $("#goalId").val($(this).closest(".goal").attr("data-goalid"));
    $("#type").val($(this).closest(".goal").attr("data-type"));
  });
  $("#goals #btns input.secondary").on("click", function (e) {
    $("input").prop("required", false);
  });
  $(".goal .compl").on("click", function () {
    if ($(this).hasClass("disabled")) return;
    $(this).addClass("disabled").css("opacity", 0.5);
    var status = "Y";
    var newStatus = "completed";
    var $this = $(this);
    if ($(this).hasClass("completed")) {
      newStatus = "incomplete";
      status = "N";
    }
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: { action:'fw_career_plan_update', fieldname: $(this).data("which"), complstatus: status, goaltype: $this.closest(".goal").data("type") },
      dataType: "json",
      success: function (data) {
        console.log($this.attr("class"));
        $this.removeClass("disabled").css("opacity", 1).removeClass("completed").removeClass("incomplete").addClass(newStatus);
        if (data[0] === "success") {
          window.location.reload();
        } else if (data.errors.length > 0) {
          for (var i = 0; i < data.errors.length; i++) {
            //$cur.children('.errors').append('<p class="error">'+data.errors[i]+'</p>');
          }
        } else {
          //$cur.children('.errors').append('<p class="error">'+data+'</p>');
        }
      },
      error: function () {},
    });
  });
  $(".save-goal").on("click", function (e) {
    if ($(this).hasClass("disabled")) {
      e.preventDefault();
      return false;
    }
    $(".save-goal").addClass("disabled");
  });
});
